"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ludwigTheming_1 = __importDefault(require("../constants/ludwigTheming"));
const drawRectangle_1 = __importDefault(require("./draw/drawRectangle"));
const drawText_1 = __importDefault(require("./draw/drawText"));
const drawTutorialHUD = () => {
    const width = ludwigTheming_1.default ? 224 : 218;
    const x = 20;
    (0, drawRectangle_1.default)("#000000", .25, x - 2, 4, width, 63, 10003);
    (0, drawText_1.default)(`${ludwigTheming_1.default ? "Coots" : "Kitty"} wants food! Guide her to cause a ruckus and get ${ludwigTheming_1.default ? "Ludwig" : "owner"}'s attention!`, "#ffffff", x, 6, 1, width - 4, 10, "left", "top");
    (0, drawText_1.default)("- Mouse to move. Avoid cat toys!", "#ffffff", x, 30, 1, width - 4, 2, "left", "top");
    (0, drawText_1.default)("- Click/space to claw objects.", "#ffffff", x, 43, 1, width - 4, 2, "left", "top");
    (0, drawText_1.default)("- M to meow.", "#ffffff", x, 56, 1, width - 4, 2, "left", "top");
};
exports.default = drawTutorialHUD;
